import React from 'react';
import { getThumbnailUrl, isGifUrl, isVideoUrl } from '../../utils/imagePreview';
import { FaPlay } from 'react-icons/fa';
import GifIcon from '../Icons/GifIcon';

/**
 * Lightweight gallery card — no heavy hooks (useAuth, useTranslation, useNavigate).
 * Uses React.memo + loading="lazy" for performance in large grids.
 */
const GalleryCard = React.memo(({ postcard, onClick, className = '', isNew = false }) => {
    const imageUrl = getThumbnailUrl(postcard, postcard.image_url, '78x101');
    const originalUrl = postcard?.image_url || imageUrl;

    return (
        <div
            className={`relative rounded-lg border bg-white dark:bg-gray-700 shadow-sm transition-shadow hover:shadow-md border-gray-200 dark:border-gray-900 overflow-hidden flex-shrink-0 ${className}`}
            onClick={onClick}
        >
            {/* Badge: new */}
            {isNew && (
                <div className="absolute top-1 left-1 z-20 w-2.5 h-2.5 rounded-full bg-red-500 ring-1 ring-white pointer-events-none" />
            )}
            {/* Badge: gif / video */}
            {originalUrl && (
                isGifUrl(originalUrl) ? (
                    <div className="absolute bottom-1.5 right-1.5 z-20 w-6 h-6 rounded-full bg-black/20 flex items-center justify-center pointer-events-none">
                        <GifIcon className="text-white text-xs" />
                    </div>
                ) : isVideoUrl(originalUrl) ? (
                    <div className="absolute bottom-1.5 right-1.5 z-20 w-6 h-6 rounded-full bg-black/20 flex items-center justify-center pointer-events-none">
                        <FaPlay className="text-white text-xs" />
                    </div>
                ) : null
            )}

            {/* Image or video preview */}
            {imageUrl && (
                isVideoUrl(imageUrl) ? (
                    <video
                        src={imageUrl}
                        autoPlay
                        loop
                        muted
                        playsInline
                        className="w-full h-full object-cover cursor-pointer"
                        style={{ display: 'block' }}
                    />
                ) : (
                    <img
                        src={imageUrl}
                        alt=""
                        loading="lazy"
                        decoding="async"
                        className="w-full h-full object-cover cursor-pointer"
                        style={{ display: 'block' }}
                    />
                )
            )}
        </div>
    );
});

GalleryCard.displayName = 'GalleryCard';

export default GalleryCard;
